import { NgModule } from '@angular/core';
import { SdvorProductItemComponent } from '@sdvor/product/ui/v2';
import {
  CustomDecimalPipeModule,
  InViewportDirective,
  RestoreScrollPositionDirective,
  SdvorCustomPaginationComponent,
} from '@sdvor/shared/ui';
import { WishlistContentEntriesComponent } from './wishlist-content-entries.component';

@NgModule({
  imports: [
    CustomDecimalPipeModule,
    SdvorProductItemComponent,
    InViewportDirective,
    SdvorCustomPaginationComponent,
    RestoreScrollPositionDirective,
  ],
  declarations: [WishlistContentEntriesComponent],
  exports: [WishlistContentEntriesComponent],
})
export class WishlistContentEntriesModule {}
